import { PageUrls } from '@core/page-urls'
import React from 'react'
import { Button } from '@common/material'
import { localizedStrings } from '@core/strings'
import { Box } from '@fundamentals'
import { ActionCard } from '@elements'
import { useRouter } from 'next/router'
import { Checklist } from '@core/entities/checklist/Checklist'

type RequestedChangesCardProps = {
  organisationId: number
  projectId?: number
  checklist: Checklist
}

export const RequestedChangesCard: React.FC<RequestedChangesCardProps> = ({
  organisationId,
  projectId,
  checklist,
}) => {
  const router = useRouter()
  if (!checklist.isAwaitingChanges()) {
    return null
  }

  const { requestedAt, requestedBy } = checklist.lastRequestedChange
  const { firstName, lastName } = requestedBy
  const { dateString, timeString } = Utils.getDate(requestedAt)

  return (
    <ActionCard
      title={localizedStrings.changesRequested}
      description={checklist.lastRequestedChange.comment}
      info={
        <Box>
          <Box>{`${localizedStrings.requestedBy}: ${firstName} ${lastName}`}</Box>
          <Box>{`${localizedStrings.date}: ${dateString} ${timeString}`}</Box>
        </Box>
      }
      BottomComponent={
        !!checklist.hasPermission('ADDRESS_REQUESTED_CHANGES') && (
          <Button
            data-test='respond-to-changes'
            variant='contained'
            fullWidth
            onClick={() => {
              if (projectId) {
                router.push(
                  PageUrls.addressRequestedProjectChecklistChanges({
                    organisationId,
                    projectId,
                    checklistId: checklist.id,
                  }),
                )
              } else {
                router.push(
                  PageUrls.addressRequestedChecklistChanges({
                    organisationId,
                    checklistId: checklist.id,
                  }),
                )
              }
            }}
          >
            {localizedStrings.addressChanges}
          </Button>
        )
      }
      sx={{ mb: 1.5, borderColor: 'primary.main', borderWidth: 2 }}
    />
  )
}
